const { ccclass, property } = cc._decorator;
import YXXTableViewBase from "../table/yxx_table_view_base";
import GameUtil from "../../../../utility/game_util";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import EffectCpCtr, { EffectName } from "./effect_cp_ctr";
import NodePoolUtil from "../../../longhudou/module/node_pool_util";
import Utility from "../../../../utility/utility";
import { CountUp } from "../../../../lib/countUp";
import { IUserData } from "../../../public/model_data";
import Util from "../../../longhudou/module/util";
import LanguageManager from "../../../../manager/language_manager";
import UserDataManager from "../../../../manager/user_manager";
import PromiseUtility from "../../../../utility/promiseUtility";
import CpTableSound from "./sound_cp_ctr";
import { RoadMap_cp_view } from "../roadmap_cp/roadmap_cp_view";
import PlayAnim from "../../../../animtion/play_anim";

@ccclass
export default abstract class CpTableView extends YXXTableViewBase {

    @property(cc.Node)
    nodeBox: cc.Node = null

    @property(SpriteFrameHolder)
    spriteFrameHolderNumBig: SpriteFrameHolder = null

    @property(SpriteFrameHolder)
    spriteFrameHolderNumSmall: SpriteFrameHolder = null

    @property(SpriteFrameHolder)
    spriteFrameHolderNum1: SpriteFrameHolder = null

    @property(cc.Sprite)
    spriteResultNum: cc.Sprite = null

    @property(cc.Sprite)
    spriteResultNumSmall: cc.Sprite = null

    @property(cc.Node)
    nodeBoxNumRoot: cc.Node = null

    @property(NodePoolUtil)
    nodePool_jetton: NodePoolUtil = null

    @property(NodePoolUtil)
    nodePool_jetton_open: NodePoolUtil = null
    
    @property(cc.Node)
    nodeAnimMask: cc.Node = null

    @property(SpriteFrameHolder)
    spriteHolderResultWinCard: SpriteFrameHolder = null

    @property(SpriteFrameHolder)
    spriteHolderResultLoseCard: SpriteFrameHolder = null

    @property(cc.Sprite)
    spriteResultCard: cc.Sprite = null

    @property(cc.Node)
    nodeBeBankerTip: cc.Node = null

    @property(RoadMap_cp_view)
    roadMapView: RoadMap_cp_view = null

    @property(cc.Node)
    nodeInputMask: cc.Node = null

    protected m_isPlayingAreaTips: boolean = false

    tableSound: CpTableSound = new CpTableSound()

    get isPlayingAreaTips(): boolean{
        return this.m_isPlayingAreaTips
    }

    get selfPosIndex(): number{
        return 7
    }

    get othersPosIndex(): number{
        return 6
    }


    //初始化下注按钮
    initBetBtn(jettonDatas, isFree) {
        this.jettonPool = this.nodePool_jetton
        this.jettonPool.initNodePool(100) //初始化筹码对象池
        this.nodePool_jetton_open.initNodePool(100)
        this.btnNodeByBetType = {}
        this.isFreeGame = isFree
        let jettonParent = this.betObj
        this.betTypeByIndex = []
        for (let index = 0; index < 5; index++) {
            let objName = (index + 1).toString() 
            const obj = cc.find(objName, jettonParent)
            const count = jettonDatas[index]
            // if (!isFree){
            //     let spr = obj.getComponent(cc.Sprite)
            //     spr.spriteFrame = this.jettonAtlas.getSpriteFrame("public_bet_" + count)
            // }
            // else{
                let tmpCount = (GameUtil.currencyFormatting(count, 1, true))
                
            //}
            let styles = ['blue', 'red', 'red_down']
            let styleObjList = {}
            for (let i = 0; i < styles.length; i++) {
                const style = styles[i];
                let styleObj: any = {}
                styleObj.node = cc.find(style, obj)
                styleObj.countLab = cc.find('Count', styleObj.node).getComponent(cc.Label)
                styleObj.countLab.string = tmpCount
                styleObjList[style] = styleObj
            }

            let mask = cc.find("Mask", obj)
            let maskEvent = null
            if (mask != null){
                maskEvent = mask.getComponent(cc.BlockInputEvents)
            }
            this.betTypeByIndex[count] = index
            this.btnNodeByBetType[count] = obj
            let btnObj: any = {
                BtnObj:obj.getComponent(cc.Button),
                Count:count,
                Mask:maskEvent,
                setState: function(styleName: string){
                    for (const key in styleObjList) {
                        if (styleObjList.hasOwnProperty(key)) {
                            const styleObj = styleObjList[key];
                            styleObj.node.active = styleName == key
                        }
                    }
                },
                setColor(color: cc.Color){
                    for (const key in styleObjList) {
                        if (styleObjList.hasOwnProperty(key)) {
                            const styleObj = styleObjList[key];
                            styleObj.node.color = color
                            styleObj.countLab.node.color = color
                        }
                    }
                }
            }
            btnObj.BtnObj.node.targetOff(this)
            btnObj.BtnObj.node.on(cc.Node.EventType.TOUCH_START, function(){
                btnObj.setState('red_down')
            }, this);
            btnObj.BtnObj.node.on(cc.Node.EventType.TOUCH_MOVE, function(event){
                let touch = event.touch;
                let hit = btnObj.BtnObj.node['_hitTest'](touch.getLocation());
                if (hit) {
                    btnObj.setState('red_down')
                } else {
                    btnObj.setState('blue')
                }
            }, this);
            btnObj.BtnObj.node.on(cc.Node.EventType.TOUCH_END, function(){
                btnObj.selected = !btnObj.selected
                let styleName = btnObj.selected ? 'red_down': 'blue'
                btnObj.setState(styleName)
            }, this);
            btnObj.BtnObj.node.on(cc.Node.EventType.TOUCH_CANCEL, function(){

            }, this);
            btnObj.setState('blue')
            this.jettonItemBtns[objName] = btnObj
        }

        let nodeAutoBtnNorml = cc.find('normal', this.autoBetBtn.node)
        let nodeAutoBtnDown = cc.find('down', this.autoBetBtn.node)
        let setNormal = function(normal){
            nodeAutoBtnDown.active = !normal
            nodeAutoBtnNorml.active = !!normal
        }
        this.autoBetBtn.node.on(cc.Node.EventType.TOUCH_START, function(){
            if(!this.autoBetBtn.enabled){
                return
            }
            setNormal(false)
        }, this)

        this.autoBetBtn.node.on(cc.Node.EventType.TOUCH_MOVE, (event)=>{
            if(!this.autoBetBtn.enabled){
                return
            }
            let touch = event.touch;
            let hit = this.autoBetBtn.node['_hitTest'](touch.getLocation());
            if (hit) {
                setNormal(false)
            } else {
                setNormal(true)
            }
        }, this)

        this.autoBetBtn.node.on(cc.Node.EventType.TOUCH_END, function(){
            if(!this.autoBetBtn.enabled){
                return
            }
            setNormal(true)
        }, this)
        this.autoBetBtn.node.on(cc.Node.EventType.TOUCH_CANCEL, function(){
            if(!this.autoBetBtn.enabled){
                return
            }
            setNormal(true)
        }, this)

        this.jettonDatas = jettonDatas
    }

    //初始化下注区域
    initBetArea(betNameList) {
        if (betNameList == null){ return }
        for (let index = 0; index < betNameList.length; index++) {
            const betName = betNameList[index].toString();
            let obj = cc.find("BetArea/" + betName, this.node)
            if (obj != null){
                let countNode = cc.find("BetArea/TipsBet/" + betName + "/CountNode", this.node)
                let countLab = cc.find("Number", countNode).getComponent(cc.Label)
                let resultObj = cc.find("BetArea/TipsBet/" + betName + "/Win", this.node)
                let totalLab = cc.find("BetArea/TipsBet/" + betName + "/Total/Number", this.node).getComponent(cc.Label)
                let nodeNum = cc.find('Centre/table/ticket' + betName + '/bg/num', this.node)
                let nodeSelect = cc.find(`BetArea/TipsBet/${betName}/select`, this.node)
                let nodeFlick = cc.find(`BetArea/TipsBet/${betName}/flick`, this.node)
                let resultAmin = null
                if (resultObj != null){
                    resultAmin  = resultObj.getComponent(cc.Animation)
                }
                this.betArea[betName] = { Obj: obj, CountNode: countNode, ResultObj: resultAmin, CountLab: countLab, TotalLab: totalLab, nodeNum: nodeNum, nodeSelect: nodeSelect, nodeFlick: nodeFlick }
                this.betCounts[betName] = 0
            }
        }
    }

    initRankPlayerInfo() {

        for (let index = 0; index < this.selfPosIndex; index++) {
            let itemObj = cc.find("Centre/Players/Player" + (index + 1), this.node)
            let noplayer = cc.find("NoPlayer", itemObj)
            let bgFrame = cc.find("Bg/frame", itemObj)
            let playerInfo = cc.find("Centre/Players/PlayerInfo"+ (index + 1), this.node)
            let nameLab = cc.find("LabNode/Name"+ (index + 1), this.node).getComponent(cc.Label)
            let iconSpr = cc.find("IconBg/Icon", playerInfo).getComponent(cc.Sprite)
            let moneyLab = cc.find("LabNode/GoldCount" + (index + 1), this.node).getComponent(cc.Label)
            let winLab = cc.find("WinLose/shuzi/Count", itemObj).getComponent(cc.Label)
            let winAmin = cc.find("WinLose", itemObj).getComponent(cc.Animation)
            let startPos = cc.find("BetArea/StartPos" + (index + 1), this.node)
            this.playerItems[index] = { Obj: itemObj, StartPos: startPos, Name: nameLab, Icon: iconSpr, Money: moneyLab, Win: winLab, WinAmin: winAmin, PlayerInfo: playerInfo, NoPlayer: noplayer, bgFrame: bgFrame }
        }

        let myselfObj = cc.find("Bottom/Player", this.node) //PlayerBg
        let nameLab = cc.find("ID", myselfObj).getComponent(cc.Label)
        let iconSpr = cc.find("Head/Mask/HeadImage", myselfObj).getComponent(cc.Sprite)
        let moneyLab = cc.find("GoldCount", myselfObj).getComponent(cc.Label)
        let winLab = cc.find("WinLose/shuzi/Count", myselfObj).getComponent(cc.Label)
        let winAmin = cc.find("WinLose", myselfObj).getComponent(cc.Animation)
        let startPos = cc.find("BetArea/StartPos0", this.node)
        this.playerItems[this.selfPosIndex] = { Obj: myselfObj, StartPos: startPos, Name: nameLab, Icon: iconSpr, Money: moneyLab, Win: winLab, WinAmin: winAmin, PlayerInfo: null, NoPlayer: null }
        this.caiChiPos = cc.find("BetArea/StartPos10", this.node)
    }

    hidePlayerItem() {
        super.hidePlayerItem()
        for (const key in this.playerItems) {
            if (this.playerItems.hasOwnProperty(key)) {
                const element = this.playerItems[key];
                if (this.isShowPlayerIndex[key] == null && element.PlayerInfo != null) {                    
                    element.bgFrame.active = false
                }
            }
        }
    }

    updatePlayerInfo(playerData: any, isUpdate, isMySelf) {
       
        let self = this
        let playerObjIndex = 0
        if (playerData.richRank == 0) {
            playerObjIndex = this.selfPosIndex
        }
        else {
            playerObjIndex =  playerData.richRank - 1
        }
        
        if (this.playerItems[playerObjIndex] == null) { return }
        
        if (this.playerItems[playerObjIndex].PlayerInfo != null) {
            this.playerItems[playerObjIndex].PlayerInfo.active = true
            this.playerItems[playerObjIndex].NoPlayer.active = false
            this.playerItems[playerObjIndex].bgFrame.active = true
        }
        UserDataManager.setUserJsonData(playerData.userData)
        self.getUserData(playerData.id, (data: IUserData) => {
            function _showUserData(){
                self.playerItems[playerObjIndex].Name.string = GameUtil.cutStr(data.name)
                self.playerItems[playerObjIndex].Icon.spriteFrame = data.avatarSprite 
            }
            //排行榜玩家变更 需要改变
            if (self.playerItems[playerObjIndex].Id != null && playerObjIndex != self.selfPosIndex  ){
                if (self.playerItems[playerObjIndex].Id != playerData.id){
                    self.playerItems[playerObjIndex].Name.string = ""
                    self.changeHeadActon(this.playerItems[playerObjIndex].Icon, _showUserData)
                }else{
                    _showUserData()
                }
                
            }
            else{
                _showUserData()
            }
            self.playerItems[playerObjIndex].Id = playerData.id

        })

        if (playerData.winLoss != null && playerData.winLoss != "") {
            let winNum = Number(playerData.winLoss)
            self.scheduleOnce(function () {
                if (winNum > 0) {
                    //存好要飘筹码得数据
                    if (self.winJettonsById[playerData.id] == null) {
                        self.winJettonsById[playerData.id] = self.getCurrentJettons(Math.ceil(winNum), null, this.betjettons)
                        self.startPosById[playerData.id] = self.playerItems[isMySelf ? self.selfPosIndex : playerObjIndex].StartPos
                    }
                }               
                
            }, 0.3)
            self.scheduleOnce(function (){
                self.playerItems[playerObjIndex].Money.string = GameUtil.currencyFormatting(Number(playerData.balance))
                if (Number(playerData.actualWinLoss) > 0) {
                    let winStr = "+" + GameUtil.currencyFormatting(Number(playerData.actualWinLoss))
                    self.playerItems[playerObjIndex].Win.string = winStr
                    self.playerItems[playerObjIndex].WinAmin.play()
                }
            }, 0.0) 
            
            self.scheduleOnce(function (){
                if (playerObjIndex == self.selfPosIndex){ 
                    self.showSelfResultCount(playerData) 
                }
            }, 1.5) 
        }

        else {
            //角色得信息
            if (isUpdate) {
                self.playerItems[playerObjIndex].Money.string = GameUtil.currencyFormatting(Number(playerData.balance))
            }

        }
        this.isShowPlayerIndex[playerObjIndex] = { Id: playerData.id, Obj: this.playerItems[playerObjIndex].StartPos, Money: self.playerItems[playerObjIndex].Money, isMySelf: isMySelf }
    }


    //刷新下注区域显示数据
    refreshBetArea(totleData: any, mySelfData: any, isForced: boolean = false) {
        let needShowSelectAreaList = []
        let needRefreshAreaSelect = false
        for (let index = 1; index <= 12; index++) {
            let refreshed = false
            for (const data of mySelfData) {
                if(data.area == index){
                    if (this.betCounts[data.area] <= data.amount || isForced) {
                        this.betCounts[data.area] = data.amount
                    }
                    if (this.betCounts[data.area] != null && this.betCounts[data.area] > 0){
                        needShowSelectAreaList.push(index)
                        let lastCount = this.betArea[data.area].CountLab['_lastCount'] || 0
                        this.betArea[data.area].CountLab['_lastCount'] = this.betCounts[data.area]
                        this.countChange(this.betArea[data.area].CountLab, lastCount, this.betCounts[data.area], true)
                        refreshed = true
                        needRefreshAreaSelect = true
                    }else{

                    }                                
                    break
                }                
            }
            if(!refreshed){
                needRefreshAreaSelect = true
                let label = this.betArea[index].CountLab
                label['_lastCount'] = 0
                label.string = GameUtil.currencyFormatting(0, 2, false, true)
            }
        }
        needRefreshAreaSelect && this.showSelectedAreas(needShowSelectAreaList)
        for (const data of totleData) {
            let lastCount = this.betArea[data.area].TotalLab['_lastCount'] || 0
            this.betArea[data.area].TotalLab['_lastCount'] = data.amount
            this.countChange(this.betArea[data.area].TotalLab, lastCount, data.amount, true)
        }
    }

    protected hideBetAreaCount(area){
        area.CountLab['_lastCount'] = 0
        area.CountLab.string = GameUtil.currencyFormatting(0, 2, false, true)
        area.TotalLab['_lastCount'] = 0
        area.TotalLab.string = GameUtil.currencyFormatting(0, 2, false, true)
    }

    //播放自己的下注动画 本地的 未经过服务器校验
    //动画 下注 已经自身的金币都需要先本地更新 后面有服务器再校验
    playBetSelfAmin(bet, area, index, goldCount) {
        let betData = {
            count: 1,
            type: bet,
            obj: null,
            area: area
        }
        let startPos = this.playerItems[this.selfPosIndex].StartPos
        let o = this.flyBetAmin(betData, area, startPos.position, true, startPos, null)
        for (const key in this.isShowPlayerIndex) {
            if (this.isShowPlayerIndex.hasOwnProperty(key)) {
                const element = this.isShowPlayerIndex[key];
                if (element.isMySelf) {
                    element.Money.string = GameUtil.currencyFormatting(goldCount, 2, false, true)
                }

            }
        }
        let lastTotalBet = this.betCounts[area]
        this.betCounts[area] = this.betCounts[area] + bet
        this.betArea[area].CountLab['_lastCount'] = this.betCounts[area]
        this.countChange(this.betArea[area].CountLab, lastTotalBet, this.betCounts[area], true)
        this.betArea[area].CountNode.active = true
        betData.obj = o
        this.betDataByIndex[index] = betData
        this.tableSound.playBet(true)

        this.eventDispatch("refresh_multiple_gold",goldCount);
    }

     //更新筹码遮罩
     updateJettonMask(balance, isMask, isAllGray?){
         if(this._moduleBase['isMyBanker']){
             return
         }
        let isAllMask = true
        let needAutoChoose = false
        for (const key in this.jettonItemBtns) {
            if (this.jettonItemBtns.hasOwnProperty(key)) {
                const element = this.jettonItemBtns[key];
                let isGray = isAllGray
                if(element.Count > balance){
                    isGray = true
                    if(this.curChooseJetton == element.BtnObj.node){
                        needAutoChoose = true
                    }
                }
                Utility.setNodeGray(element.BtnObj.node, isGray)
                element.BtnObj.enabled = !isGray
                if (!isGray || isMask){
                    if (element.Mask != null){
                        element.Mask.enabled = isMask
                        element.Mask.node.opacity =  isMask ? 255 : 0
                    }
                    if (isAllMask){ isAllMask = false }
                }     
                element.setColor((isMask && !isGray)? new cc.Color(114, 114, 114, 255): cc.Color.WHITE)
            }
        }
        if(isAllMask){
            this.showChooseJetton(null)
        }else if(isMask){
            this.showChooseJetton(null)
        }else if(isAllGray){
            this.showChooseJetton(null)
        }else{
            if(needAutoChoose){
                this.curChooseJetton = null
                const element = this.jettonItemBtns["1"];
                if (element.Count <= balance){
                    this.curChooseJetton = element.BtnObj.node
                }
            }
            let curChoose = this.curChooseJetton
            this.showChooseJetton(null)
            this.showChooseJetton(curChoose)
        }
    }

    //选择筹码
    showChooseJetton(obj: cc.Node, click?: boolean) {  
        if(!obj){
            this._moduleBase['currentBetType'] = null
        }
        for (const key in this.jettonItemBtns) {
            if (this.jettonItemBtns.hasOwnProperty(key)) {
                const element = this.jettonItemBtns[key];
                if (obj == element.BtnObj.node){
                    if(this.curChooseJetton == obj){
                        if(click){
                            this.curChooseJetton = null
                            this._moduleBase['currentBetType'] = null
                            continue
                        }                                              
                    }
                    this.curChooseJetton = obj
                    this._moduleBase['currentBetType'] = this.jettonItemBtns[obj.name].Count
                    if(!click){
                        element.setState('red_down')  
                        element.selected = true  
                    }                                                                                                
                }
                else{
                    element.selected = false
                    element.setState('blue')
                }
            }
        }
    }

    flickerJettons(){
        for (const key in this.jettonItemBtns) {
            if (this.jettonItemBtns.hasOwnProperty(key)) {
                const element = this.jettonItemBtns[key];
                let anim = element.BtnObj.getComponent(cc.Animation)
                anim.play()
            }
        }
    }

    refreshSelectArea(area: number){
        let name = area.toString()
        for (const key in this.betArea) {
            if (this.betArea.hasOwnProperty(key)) {
                const element = this.betArea[key]
                if(key.toString() == name){                    
                    element.nodeSelect.active = true
                }
            }
        }        
    }

    showSelectedAreas(areaList: number[]){        
        for (const key in this.betArea) {
            if (this.betArea.hasOwnProperty(key)) {
                const element = this.betArea[key]
                let needShow = false
                for (let index = 0; index < areaList.length; index++) {
                    const area = areaList[index];
                    if(key.toString() == area.toString()){
                        needShow = true                        
                        break
                    }                    
                }
                element.nodeSelect.active = needShow
            }
        }    
    }

    //播放准备动画
    playReadyAmin(isPlay){
        if (isPlay){
            this.nodeAnimMask.active = true
            this.nodeBoxNumRoot.active = true
            this.nodeBox.active = false
            this.effectCtr.playEffectAnim(Number(EffectName.Ready), () => {
                this.nodeBoxNumRoot.active = false
                this.nodeBox.active = true
                this.nodeAnimMask.active = false
            }, true)
            this.tableSound.playYaoGu()
        }
    }

    playResultNumFly(number: number, duration: number){        
        let effectCtr = this.effectCtr as EffectCpCtr                     
        let node: cc.Node = this.betArea[number.toString()].nodeNum
        let targetPos = effectCtr.resultNum.node.parent.convertToNodeSpaceAR(node.parent.convertToWorldSpaceAR(node.position))        
        let moveAnim = cc.moveTo(duration, cc.v2(targetPos.x,targetPos.y))
        effectCtr.resultNum.node.runAction(moveAnim)
    }

    //显示开奖结果
    showResulet(resuletData: any, m_callback: Function, isAmin: boolean = true) {
        if (resuletData == null){ return }
            
            this.result[0].spriteFrame = this.spriteFrameHolderNum1.getSpriteFrameByKey(resuletData.result.toString())
            this.result[0].node.active = true
            if(resuletData.result > 9){
                this.result[0].node.scale = 1.4
            }else{
                this.result[0].node.scale = 1
            }
            this.nodeBoxNumRoot.active = false

            let effectCtr = this.effectCtr as EffectCpCtr
            this.nodeBox.active = false
            this.nodeAnimMask.active = true
            effectCtr.playEffectAnim(Number(EffectName.Result), ()=>{
                this.result[0].node.active = false
                this.nodeBox.active = true                
                                 
            })
              
            //播放开奖数字 
            effectCtr.resultNum.node.position = cc.v3(-2.559, 48.848999) 
            effectCtr.resultNum.node.stopAllActions()
            this.spriteResultNum.spriteFrame = this.spriteFrameHolderNumBig.getSpriteFrameByKey(resuletData.result.toString()) 
            this.spriteResultNumSmall.spriteFrame = this.spriteFrameHolderNumSmall.getSpriteFrameByKey(resuletData.result.toString()) 
            effectCtr.playEffectAnim(Number(EffectName.ResultNum), ()=>{                
                effectCtr.resultNum.node.position = cc.v3(-2.559, 48.848999)                  
                m_callback && m_callback()
            })
            this.doScheduleOnce(()=>{
                this.roadMapView.showPanel([resuletData.result], true)
                this.playResultNumFly(resuletData.result, 0.27)
                this.doScheduleOnce(()=>{
                    this.tableSound.playNumOut()
                }, 0.12)                
            }, 6)
            this.doScheduleOnce(()=>{
                this.tableSound.playOpenResult()
            }, 2)  
            this.doScheduleOnce(()=>{                
                this.tableSound.playDianShu(resuletData.result)
            }, 3.5)          
    }

    //飞筹码动画
    flyBetAmin(bet: any, area: number, startPos: cc.Vec2, isPlay: boolean, startNode: cc.Node, endNode: cc.Node): cc.Sprite {
        if(!isPlay){
            return
        }
        if (this.betArea[area].Obj == null){ return }
        let self = this
        startPos = this.node.convertToWorldSpaceAR(startPos)
        startPos = this.betArea[area].Obj.convertToNodeSpaceAR(startPos)
        for (let index = 0; index < bet.count; index++) {
            let countType = this.isFreeGame ? 0 : bet.type
            let o = this.jettonPool.getNode(countType)
            o.node.parent = this.betArea[area].Obj
            let pos = this.betArea[area].nodeNum.position
            o.node.active = true
            if (this.betjettons[bet.type] == null) {
                this.betjettons[bet.type] = new Array<cc.Sprite>()
            }
            let dis = pos.add(startPos.mul(-1)).mag()
            this.moveToPos(startPos, pos, o.node, ()=>{                    
                let item = this.nodePool_jetton_open.getNode(0)
                item.node.parent = this.betArea[area].Obj
                item.node.position = o.node.position
                item.node.active = true
                o.node.active = false
                this.jettonPool.setNode(o)
                this.doScheduleOnce(()=>{
                    item.node.active = false
                    this.nodePool_jetton_open.setNode(item)
                }, 0.4)
            }, 0.8 * dis / 700)

        }
        return null //为了自己下筹码用到而已

    }

    //下注失败找回一个
    playBetDefeated(index, goldCount) {
        let self = this
        let betData = this.betDataByIndex[index]
        if (betData == null) { return }
        let lastTotalBet = this.betCounts[betData.area]
        this.betCounts[betData.area] = this.betCounts[betData.area] - betData.type
        this.betArea[betData.area].CountLab['_lastCount'] = this.betCounts[betData.area]
        this.countChange(this.betArea[betData.area].CountLab, lastTotalBet, this.betCounts[betData.area], true)
        this.betArea[betData.area].CountNode.active = true
        for (const key in this.isShowPlayerIndex) {
            if (this.isShowPlayerIndex.hasOwnProperty(key)) {
                const element = this.isShowPlayerIndex[key];
                if (element.isMySelf) {
                    element.Money.string = GameUtil.currencyFormatting(goldCount, 2, false, true)
                }

            }
        }

        this.betDataByIndex[index].count = 0
    }

    protected countChange(label: cc.Label, oldValue: number, newValue: number, needFormat?: boolean){
        let chouma = new CountUp(null,newValue,{
            startVal: oldValue,
            decimalPlaces: 2,
            duration: 0.5,
            useEasing: false,
            useGrouping: false,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ',',
            decimal: '.',
            prefix: '',
            suffix: ''
        })
        if(!chouma.error){
            let tmp = label['_countUp']
            tmp && tmp.reset()
            label['_countUp'] = chouma
            chouma.start((n)=>{
                if (this && this.isValid) {
                    label.string = needFormat? GameUtil.currencyFormatting(Number(n), 2, false, true): n
                }
            })
        }
    }

    playResultAmin(resuletData, betData, jackpotDataAdd) {
        
    }

    showSelfResultCount(playerData){
        let self = this
        this.getUserData(playerData.id, (data: IUserData) => {
            this.winLoseId.string = GameUtil.cutStr(data.name)
            this.winLoseHead.spriteFrame = data.avatarSprite
        })
        this.tableSound.playResult(Number(playerData.actualWinLoss) > 0)
        let resultNum = (this._moduleBase['currentResult'] && this._moduleBase['currentResult'].result) || 0
        let str = null
        let effectCtr = this.effectCtr as EffectCpCtr
        if (Number(playerData.actualWinLoss) > 0) {
            this.loseCount.string = ""
            str = "+" + GameUtil.currencyFormatting(Number(playerData.actualWinLoss))
            this.winCount.string =  str
            this.spriteResultCard.spriteFrame = this.spriteHolderResultWinCard.getSpriteFrameByKey(resultNum.toString())            
            effectCtr.playEffectAnim(Number(EffectName.SelfWin), null, false, null, 1)
        }
        else{
            this.winCount.string = ""
            str = GameUtil.currencyFormatting(Number(playerData.actualWinLoss))
            this.loseCount.string = str
            this.spriteResultCard.spriteFrame = this.spriteHolderResultLoseCard.getSpriteFrameByKey(resultNum.toString())
            effectCtr.playEffectAnim(Number(EffectName.SelfLose), null, false, null, 1)
        }
        self.scheduleOnce(function (){
            self.eventDispatch("Game_Table_Settlement", self.playerItems[self.selfPosIndex].Obj)
        }, 1)
        for (const key in this.betArea) {
            if (this.betArea.hasOwnProperty(key)) {
                const element = this.betArea[key];
                this.hideBetAreaCount(element)
                this.betCounts[key] = 0
            }
        }
        this.showSelectedAreas([])
    }


    updateBanker(userId, bankerData){
        let self = this
        this.banker.active = true
        this.sysBanker.active = !userId
        this.nodeBeBankerTip.active = !userId
        this.bankerRound.node.parent.active = !!userId
        self.bankerLoseLab.string = ""
        self.bankerWinLab.string = ""
        this.bankerGold.string = ''
        self.bankerName.string = ''
        if(userId){
            this.bankerRound.string = LanguageManager.t("lhd_juShu").format(bankerData.banker.round == null ? 1 : bankerData.banker.round);
            UserDataManager.setUserJsonData(bankerData.banker.userData)
            this.getUserData(userId, (data : IUserData)=> {
                self.bankerName.string = GameUtil.cutStr(data.name)
                self.bankerHead.spriteFrame = data.avatarSprite 
                if (self.lastBankerId == null || self.lastBankerId != userId){
                    self.lastBankerId = userId
                    self.tipsBankerName.string = data.name
                    self.tipsBankerIcon.spriteFrame = data.avatarSprite
                    self.tipsBankerNode.active = true 
                    //播放新庄家提示
                    self.scheduleOnce(()=>{
                        self.tipsBankerNode.active = false
                    }, 4.5)
                }
            })

            this.bankerGold.string = GameUtil.currencyFormatting(Number(bankerData.banker.balance))
            if (bankerData.winLoss != null && bankerData.winLoss != ''){
                let winNum = Number(bankerData.winLoss) 
                self.scheduleOnce(function(){
                    if (winNum >= 0)
                    {
                        let winStr = "+" + GameUtil.currencyFormatting(winNum) 
                        self.bankerWinLab.string = winStr
                        self.bankerLoseLab.string = ""
                    }
                    else{
                        self.bankerWinLab.string = ""
                        self.bankerLoseLab.string = bankerData.winLoss
                    }
                    self.bankerWinLose.play()
                },1.3)
            }else{

            }
        }
        
    }

    //下注提示
    showBetTips(isStart: boolean) {
        let self = this
        if (isStart){
            this.effectCtr.playEffectAnim(Number(EffectName.StartBet))
            this.doScheduleOnce(()=>{
                this.playAreaFlicker()
            }, 2.4)            
        }
        else{
            this.effectCtr.playEffectAnim(Number(EffectName.EndBet))
        }
        self.tableSound.playStartOrBetBet(isStart)
    }


    playAreaFlicker(duration?: number, onFinish?: Function){
        let self = this
        this.m_isPlayingAreaTips = true
        let list = []        
        for (let index = 1; index <= 12; index++) {
            const area = this.betArea[index];
            let fun = function(cb){
                self.flickerAnim(area.nodeFlick, duration, cb)
            }
            list.push(fun)
        }
        PromiseUtility.all(list).then(function(){
            self.m_isPlayingAreaTips = false
            onFinish && onFinish()
        })
    }


    protected flickerAnim(node: cc.Node, duration?: number, onFinish?: Function){
        let self = this
        
        duration = duration || 0.83
        let lastId = node['_lastScheduleId']
        if(lastId){
            self.cancelSchedule(lastId)
            node.active = false
        }        
        node.active = true
        let id = self.doScheduleOnce(function(){
            node['_lastScheduleId'] = null
            node.active = false
        }, duration)
        node['_lastScheduleId'] = id
    }

    protected fadeAnim(node: cc.Node, out: boolean, duration: number, onFinish: Function){
        var action = out? (node.opacity = 0, cc.fadeIn(duration)): (node.opacity = 255, cc.fadeOut(duration))
        action.setTag(100)
        node.stopActionByTag(100)
        node.runAction(cc.sequence(action, cc.callFunc(onFinish)))
    }

    
    //播放下注动画 其他人得
    playOtherBetAmin(otherData: any, isPlay: boolean, isPlaySound: boolean) {
        if (otherData == null) { return }
        let m_isPlaySound = !isPlaySound && isPlay

        let areaMap = {}
        for (const item of otherData) {
            if (item.data != null) {
                for (const otherBet of item.data) {
                    if (otherBet.count != null && otherBet.count > 0) {
                        if (m_isPlaySound) {
                            m_isPlaySound = false
                            // this.tableSound.playBet(false)
                        }
                        areaMap[item.area] = areaMap[item.area] || true                        
                    }
                }
            }
        }
        for (const key in areaMap) {
            if (areaMap.hasOwnProperty(key)) {
                const element = areaMap[key];
                element && this.flyBetAmin({count: 1, type: 10}, Number(key), this.playerItems[this.othersPosIndex].StartPos.position, isPlay, this.playerItems[this.othersPosIndex].StartPos, null)
            }
        }
        this.isShowPlay = []
    }

    //播放下注动画 排行榜玩家的
    playBetAmin(betData: any, isMySelf: boolean, otherBetData: any) {
        if (betData == null && betData.data == null) { return }
        let self = this
        function getPlay(index) {
            if (self.isShowPlayerIndex[index] == null) { return }
            let showid = self.isShowPlayerIndex[index].Id
            if (showid == betData.id && self.isShowPlay[showid] == null) {
                self.isShowPlay[showid] = betData
                let o = self.isShowPlayerIndex[index].Obj
                //处理下注数据
                for (const itemData of betData.data) {
                    if (itemData.data != null) {
                        for (const bet of itemData.data) {
                            if (bet.count != null || bet.count > 0) {
                                if (index != self.selfPosIndex) {
                                    self.flyBetAmin(bet, itemData.area, o.position, true, o, null)
                                }
                                for (const otherArea of otherBetData) {
                                    if (otherArea.area == itemData.area) {
                                        for (const otherBet of otherArea.data) {
                                            if (otherBet.type == bet.type) {
                                                otherBet.count = otherBet.count - bet.count
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (isMySelf) {
            getPlay(self.selfPosIndex)
        }
        else {
            for (let index = 0; index < this.isShowPlayerIndex.length; index++) {
                getPlay(index)
            }
        }
    }
}